module.exports = __webpack_public_path__ + "img/app.21fda956.png";